import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthShell, Field } from "./AuthShell";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords do not match");
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please log in.");
      nav("/login");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set new password" subtitle="Choose a strong password for your account"
      footer={<><Link to="/login" className="text-cyan-400 hover:underline">Back to Login</Link></>}>
      {!token ? (
        <div className="glass rounded-xl p-6 text-center text-sm text-slate-400">Invalid or missing reset token.</div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="New Password" testId="reset-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 8 chars" />
          <Field label="Confirm Password" testId="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat" />
          <button type="submit" disabled={loading} data-testid="reset-submit"
            className="btn-glow w-full py-3 rounded-lg font-semibold text-slate-950 inline-flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Reset Password
          </button>
        </form>
      )}
    </AuthShell>
  );
}
